import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {xor} from '../helpers/xor';

const DOMAIN_REGEX: RegExp = /^(?!https?:\/\/)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

function removeError(control: AbstractControl): void {
  if (!control.errors) return;

  delete control.errors['cNameConflict'];
  if (Object.keys(control.errors).length > 0) {
    control.setErrors(control.errors);
  } else {
    control.setErrors(null);
  }
}

function setError(control: AbstractControl): void {
  control.setErrors({...control.errors || {}, cNameConflict: true});
}

function validateRegex(control: AbstractControl): void {
  control.setErrors(Validators.pattern(DOMAIN_REGEX)(control));
}

export function cNameValidator(): ValidatorFn {
  return (group: FormGroup): ValidationErrors => {
    const cName = group.get('c_name');
    const cNameResource = group.get('c_name_resource');

    // Validate regex
    validateRegex(cName);
    validateRegex(cNameResource);

    // Valid if both are empty or filled
    if (!xor(!!cName.value, !!cNameResource.value)) {
      removeError(cName);
      removeError(cNameResource);
    } else {
      !!cName.value ?  removeError(cName) : setError(cName);
      !!cNameResource.value ?  removeError(cNameResource) : setError(cNameResource);
    }

    return null;
  }
}
